module.exports = __webpack_public_path__ + "media/icons/de-fa697234c5d35f23ec291aab988f2d80.svg";